// DataInitializer.tsx
import type React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { login, fetchShopList, fetchCurrentBuser, selectUser } from '../../store/modules/authSlice';
import type { RootState } from '../../store/index';
import { useAppBridge } from '@shopify/app-bridge-react';
import PageLoading from '../PageLoading';
import { useI18n } from '@/hooks/useI18n';
import { useAppDispatch, getLatestState } from '../../store';
import { useLocation } from 'react-router-dom';
import { fetchSettings, selectOriginalSettings } from '@/store/modules/chatSettingSlice';
const shopify = useAppBridge();

interface DataInitializerProps {
  children: React.ReactNode;
}

export const DataInitializer: React.FC<DataInitializerProps> = ({ children }) => {
  const appDispatch = useAppDispatch();
  const [isInitializing, setIsInitializing] = useState(true);
  const authState = useSelector((state: RootState) => { return state.auth });
  const { changeLanguage } = useI18n();
  const location = useLocation();
  const originalSettings = useSelector(selectOriginalSettings);
  
  // 使用ref来避免不必要的渲染和跟踪初始化状态
  const initialized = useRef(false);

  // 只运行一次的初始化逻辑
  useEffect(() => {
    // 如果已经初始化过，直接返回，避免重复初始化
    if (initialized.current) return;

    const initializeData = async () => {
      try {
        console.log("🚀 初始化开始~", getLatestState());
        
        // 步骤1: 检查willlinksToken
        if (!authState.willlinksToken) {
          // 修改：使用getState获取最新的状态
          await appDispatch(login({ shopDomain: shopify.config.shop }));
        }

        // 直接从Redux store获取最新状态
        const latestAuthState = getLatestState().auth;
        if (latestAuthState.user) {
          changeLanguage(latestAuthState.user.workLang || 'en');
        }

        // if (!originalSettings?.widgetDefaultLanguage) {
        //   await appDispatch(fetchSettings());
        // }

        // console.log("🔍 检查仓库用户数据", getLatestState());
        // // 步骤2: 检查用户信息
        // if (!getLatestState()?.auth?.user) {
        //   console.log("👤正在获取用户信息");
        //   const result = await appDispatch(fetchCurrentBuser());
          
        //   // 显式类型断言，解决"result.payload"的类型为"未知"问题
        //   interface UserPayload {
        //     workLang?: string;
        //   }
        //   const userPayload = result.payload as UserPayload;
          
        //   changeLanguage(userPayload?.workLang || 'en');
        // }
        
        // // 步骤3: 检查店铺信息
        // if (!getLatestState()?.auth?.shopList || getLatestState()?.auth?.shopList.length === 0) {
        //   console.log("🏪 正在获取店铺列表");
        //   // 类型断言确保类型兼容
        //   await appDispatch(fetchShopList({ includeEmbed: true }));
        // }
        
        // 标记初始化完成
        initialized.current = true;
        console.log("✅ 初始化完成");
      } catch (error) {
        console.error("❌ 初始化失败", error);
      } finally {
        setIsInitializing(false);
      }
    };

    initializeData();
  }, []); // 使用空依赖数组确保useEffect只运行一次

  // 数据初始化中显示加载状态
  if (isInitializing && location.pathname !== '/' && location.pathname !== '/home') {
    return <PageLoading />;
  }

  // 数据初始化完成，渲染子组件
  return <>{children}</>;
};
